let counter = 0;
export default function generateClassName(rule, sheet) {
  return `AvadaFaqs-${sheet.options.classNamePrefix}-${rule.key}-jss-${counter++}`;
}
